import { Injectable } from '@angular/core';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams, GridPostParams } from 'common/models/utility-models/list-utility.model';
import { environment } from 'src/environments/environment';
import { BranchCategoryGridPostParams } from 'common/models/page-models/branch-category/branch-category-grid.model';
import { BranchesModel } from 'common/models/page-models/Branches/branches-data-model';
import { BranchesListingModel } from 'common/models/page-models/Branches/branches-grid-model';

@Injectable({
    providedIn: 'root'
})
export class BranchesGridDataService extends GridDataService<BranchesListingModel, BranchesModel> {
    
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.getBranchList, http, ss);
    }

    createInstance(): BranchesListingModel {
        return new BranchesListingModel();
    }

    


    override getGridParams(param): GridPostParams {
        return new BranchCategoryGridPostParams();
    }
  
    override getDeleteUrl(){
        return environment.apiUrl+API_URL.deleteBranch;
    }

    override transformDataModel(data: any[], param) {
        super.transformDataModel(data, param);
        this.setSystemServiceData('branchCategory', API_URL.getBranchCategoryList, new BranchCategoryGridPostParams(), 'detail');
        return data;
    }
}
